import { useLocation, matchPath } from 'react-router-dom'

const DISABLED_ROUTE_PATTERNS = [
  '/billing-schedules/:id',
  '/billing-schedules/:id/*',
  '/quotes/new',
  '/quotes/new/*',
  '/quotes/:id',
  '/quotes/:id/*',
  '/quote-templates/:id',
  '/quote-templates/:id/*',
  '/invoices/new/:id',
  '/invoices/:id',
  '/invoices/:id/*'
]

export const useIsGlobalDropzoneDisabled = (): boolean => {
  const { pathname } = useLocation()
  return isRouteDisabled(pathname)
}

export const isRouteDisabled = (pathname: string): boolean => {
  return DISABLED_ROUTE_PATTERNS.some(
    pattern => matchPath(pattern, pathname) !== null
  )
}
